import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var PaymentLogoBancontact = _ref => {
  var {
      accessibilityLabel,
      id,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'PaymentLogoBancontact',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#1E3764",
    d: "M.029 17.729v-3.168h.977c.711 0 1.168.267 1.168.82a.736.736 0 0 1-.348.655c.294.136.466.399.466.756 0 .638-.466.937-1.19.937H.029Zm.629-1.851h.466c.285 0 .407-.14.407-.398 0-.276-.221-.367-.52-.367H.658v.765Zm0 1.299h.39c.38 0 .601-.095.601-.394 0-.294-.19-.416-.547-.416H.658v.81Zm2.854.606c-.62 0-.933-.303-.933-.71 0-.448.367-.71.91-.715.135.002.27.014.403.036v-.109c0-.276-.159-.407-.462-.407a1.587 1.587 0 0 0-.597.109l-.113-.49c.194-.08.507-.135.783-.135.665 0 .995.353.995.964v1.258c-.185.095-.534.2-.986.2Zm.38-.511v-.484a1.523 1.523 0 0 0-.321-.037c-.209 0-.372.082-.372.295 0 .19.136.29.376.29a.708.708 0 0 0 .317-.064Zm1.046.457v-2.168c.325-.13.672-.198 1.023-.199.66 0 1.04.326 1.04.928v1.439h-.624v-1.394c0-.312-.145-.457-.42-.457a.948.948 0 0 0-.399.081v1.77h-.62Zm4.246-2.231-.117.493a1.378 1.378 0 0 0-.512-.113c-.366 0-.565.258-.565.683 0 .466.208.706.597.706a1.28 1.28 0 0 0 .502-.117l.1.502a1.524 1.524 0 0 1-.652.131c-.751 0-1.186-.466-1.186-1.204 0-.733.43-1.217 1.15-1.217.235-.001.467.045.683.136Zm1.35 2.285c-.697 0-1.132-.484-1.132-1.213 0-.724.435-1.208 1.132-1.208.701 0 1.126.484 1.126 1.208 0 .729-.425 1.213-1.127 1.213Zm0-.516c.32 0 .488-.267.488-.697 0-.425-.167-.692-.489-.692-.316 0-.493.267-.493.692 0 .43.177.697.494.697Zm1.488.462v-2.168c.325-.13.672-.198 1.023-.199.66 0 1.04.326 1.04.928v1.439h-.624v-1.394c0-.312-.145-.457-.42-.457a.948.948 0 0 0-.4.081v1.77h-.62Zm3.472.054c-.538 0-.815-.294-.815-.891v-.978h-.307v-.498h.307v-.502l.625-.032v.534h.502v.498h-.502v.969c0 .262.109.384.312.384.08 0 .161-.009.24-.027l.032.503c-.13.028-.262.042-.394.04Zm1.576 0c-.62 0-.932-.303-.932-.71 0-.448.367-.71.91-.715.135.002.27.014.403.036v-.109c0-.276-.159-.407-.462-.407a1.587 1.587 0 0 0-.597.109l-.114-.49c.195-.08.507-.135.783-.135.666 0 .996.353.996.964v1.258c-.185.095-.534.2-.987.2Zm.38-.511v-.484a1.524 1.524 0 0 0-.32-.037c-.209 0-.372.082-.372.295 0 .19.136.29.376.29a.709.709 0 0 0 .317-.064Zm2.744-1.774-.118.493a1.377 1.377 0 0 0-.511-.113c-.367 0-.566.258-.566.683 0 .466.208.706.597.706a1.28 1.28 0 0 0 .503-.117l.1.502a1.524 1.524 0 0 1-.652.131c-.752 0-1.186-.466-1.186-1.204 0-.733.43-1.217 1.15-1.217.234-.001.466.045.683.136Zm1.373 2.285c-.539 0-.815-.294-.815-.891v-.978h-.307v-.498h.307v-.502l.625-.032v.534h.502v.498h-.502v.969c0 .262.108.384.312.384.08 0 .161-.009.24-.027l.032.503c-.13.028-.262.042-.394.04Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_4962_1203)",
    d: "M4.385 12.977c3.305 0 4.957-2.203 6.61-4.406H.029v4.406h4.356Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_4962_1203)",
    d: "M17.604 4.164c-3.304 0-4.957 2.203-6.61 4.407h10.967V4.164h-4.357Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_4962_1203",
    x1: 2.247,
    x2: 10.269,
    y1: 10.977,
    y2: 7.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#005AB9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#1E3764"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_4962_1203",
    x1: 11.659,
    x2: 20.177,
    y1: 8.953,
    y2: 6.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FBA900"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFD800"
  }))));
};
PaymentLogoBancontact.displayName = 'PaymentLogoBancontact';
export default withProvisionalOverrideFromContext(PaymentLogoBancontact);
//# sourceMappingURL=index.js.map